import HeadImg from './head_img2'

export default {
    install: function(Vue) {
        Vue.component('HeadImg2', HeadImg)
    }
}